import React from "react";

import styled from "styled-components";

import { Currency, OrderLineItem } from "@sso/types";

import Price from "../Price/Price";

interface LineItemsProps {
  items: OrderLineItem[];
  currency: Currency;
  inclTax?: boolean;
}

const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

const FormattedPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
`;

const Description = styled.p`
  color: #a0a0a0;
  white-space: pre-wrap;
`;

const ItemGrid = styled.div`
  display: grid;
  grid-template-columns: 7fr 1fr;
  border-top: 1px solid lightGrey;
  border-bottom: 1px solid lightGrey;
  width: 100%;
  gap: 20px;
  padding: 1rem 0;
`;

const LineItems = ({ items, currency, inclTax = false }: LineItemsProps) => {
  return (
    <ItemGrid>
      {items.map((x, i) => (
        <React.Fragment key={i}>
          <Details>
            <p>{x.name}</p>
            <Description>{x.description} </Description>
          </Details>
          <FormattedPrice>
            <Price price={x.transactionCostExTax} currency={currency} />
          </FormattedPrice>
        </React.Fragment>
      ))}
    </ItemGrid>
  );
};

export default LineItems;
